var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.638,
    height: 13.684,
    viewBox: "0 0 15.638 13.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-account-login",
    "data-name": "Icon open-account-login",
    d: "M5.864,0V1.955h7.819v9.774H5.864v1.955h9.774V0ZM7.819,3.909V5.864H0V7.819H7.819V9.774l3.909-2.932Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLogin);
export default __webpack_public_path__ + "static/media/account-login.e653d5e2.svg";
export { ForwardRef as ReactComponent };